
const BASE_URL: string = '/claim-payments';

/**
 * 
 */
 export const CLAIM_PAYMENTS_PATH = {
  CLAIM_PAYMENTS: BASE_URL,
	ONBOARDING: `${BASE_URL}/onboarding`,
	PERSONAL_DATA: `${BASE_URL}/personal-data`,
	VEHICLE_DATA: `${BASE_URL}/vehicle-data`,
	POLICY_DATA: `${BASE_URL}/policy-data`,
	VEHICLE_PICTURES: `${BASE_URL}/vehicle-pictures`,
	ID_DOCUMENTS: `${BASE_URL}/id-documents`,
	VEHICLE_OWNER: `${BASE_URL}/vehicle-owner`,
	BANK_ACCOUNT: `${BASE_URL}/bank-account`,
	VEHICLE_BILL: `${BASE_URL}/vehicle-bill`,
	ATTORNEY_LETTER: `${BASE_URL}/attorney-letter`,
	COMPLETION: `${BASE_URL}/completed`,
	PROPOSAL: `${BASE_URL}/proposal`,
	MESSAGE_AGENT:`https://wa.me/5213321011715?text=Tengo%20una%20duda.`,
}